<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="方案名称" prop="name" >
        <a-input v-model="form.name" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="保险分类" prop="type" >

        <a-select v-model="form.type" placeholder="请选择保险分类">
          <a-select-option :value="5">一类</a-select-option>
          <a-select-option :value="6">二类</a-select-option>
          <a-select-option :value="7">三类</a-select-option>
          <a-select-option :value="8">四类</a-select-option>
          <a-select-option :value="9">五类</a-select-option>
          <a-select-option :value="10">六类</a-select-option>
          <a-select-option :value="11">S类</a-select-option>
          <a-select-option :value="1">A类</a-select-option>
          <a-select-option :value="2">B类</a-select-option>
          <a-select-option :value="3">C类</a-select-option>
          <a-select-option :value="4">D类</a-select-option>
        </a-select>

      </a-form-model-item>
      <a-form-model-item label="方案分类 " prop="plan" >
        <a-select v-model="form.plan" placeholder="请选择计划分类 ">
          <!-- <a-select-option :value="1">计划一</a-select-option>
          <a-select-option :value="2">计划二</a-select-option>
          <a-select-option :value="3">计划三</a-select-option>
          <a-select-option :value="4">计划四</a-select-option>
          <a-select-option :value="5">计划五</a-select-option> -->
          <a-select-option value="1">方案一</a-select-option>
          <a-select-option value="2">方案二</a-select-option>
          <a-select-option value="3">方案三</a-select-option>
          <a-select-option value="4">方案四</a-select-option>
          <a-select-option value="5">方案五</a-select-option>
          <a-select-option value="6">方案六</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="方案代码" prop="planCode" >
        <a-input v-model="form.planCode" placeholder="请输入方案代码（保司 product_scheme.scheme_code）" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="最小天数" prop="dayMin" >
        <a-input v-model="form.dayMin" placeholder="请输入最小天数" />
      </a-form-model-item>
      <a-form-model-item label="最大天数" prop="dayMax" >
        <a-input v-model="form.dayMax" placeholder="请输入最大天数" />
      </a-form-model-item>
      <a-form-model-item label="保险费用每天" prop="money" >
        <a-input v-model="form.money" placeholder="请输入保险费用每天" />
      </a-form-model-item>
      <a-form-model-item label="保险总费用" prop="totalMoney">
        <a-input v-model="form.totalMoney" placeholder="已停用：不再参与计费（保留历史数据可留空）" />
      </a-form-model-item>
      <a-form-model-item label="意外身故保障" prop="die">
        <a-input
          v-model="form.die"
          placeholder="意外身故保障"
          allow-clear
        />
      </a-form-model-item>
      <a-form-model-item label="意外医疗保障" prop="medical">
        <a-input
          v-model="form.medical"
          placeholder="意外医疗保障"
          allow-clear
        />
      </a-form-model-item>
      <a-form-model-item label="意外住院津贴" prop="allowance">
        <a-input
          v-model="form.allowance"
          placeholder="意外住院津贴"
          allow-clear
        />
      </a-form-model-item>
      <a-form-model-item label="意外险注意事项" prop="mattersNeedAttention">
        <a-textarea
          v-model="form.mattersNeedAttention"
          placeholder="填写后在雇主端、师傅端保险方案详情中展示，空则不展示"
          :auto-size="{ minRows: 3, maxRows: 8 }"
          allow-clear
        />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getInsurance, addInsurance, updateInsurance } from '@/api/insurance/insurance'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        name: null,

        type: null,

        plan: null,

        planCode: null,

        dayMin: null,

        dayMax: null,

        money: null,

        totalMoney: null,

        die: null,

        medical: null,

        allowance: null,

        createTime: null,

        mattersNeedAttention: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        name: [
          { required: true, message: '方案名称不能为空', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '保险分类 (1-A类, 2-B类,3-C类 ,4-D类, 5-一类,6-二类,7-三类,8-四类,9-五类,10-六类,11-S类)不能为空', trigger: 'change' }
        ],
        plan: [
          { required: true, message: '方案分类 (1-方案一, 2-方案二,3-方案三 ,4-方案四,5-方案五,6-方案六)不能为空', trigger: 'blur' }
        ],
        planCode: [
          { required: true, message: '方案代码不能为空', trigger: 'blur' }
        ],
        dayMin: [
          { required: true, message: '最小天数不能为空', trigger: 'blur' }
        ],
        dayMax: [
          { required: true, message: '最大天数不能为空', trigger: 'blur' }
        ],
        money: [
          { required: true, message: '保险费用每天不能为空', trigger: 'blur' }
        ],
        totalMoney: []
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        name: null,
        type: null,
        plan: null,
        planCode: null,
        dayMin: null,
        dayMax: null,
        money: null,
        totalMoney: null,
        die: null,
        medical: null,
        allowance: null,
        createTime: null,
        mattersNeedAttention: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getInsurance({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateInsurance(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addInsurance(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
